export function getClosestPoint(graph, xScale, xData, position) {

	// Convert x coordinate into a value within the scale's domain
	const domainXCoordinate = xScale.invert(position[0]);

	// Whether we are searching forwards from the start index or backwards
	const searchForwards = position[0] > (typeof graph.lastActivePositionX === 'number' ? graph.lastActivePositionX : 0);

	// The start index to start searching from when finding the nearest data point
	const startIndex = graph.lastActivePoint
		? graph.lastActivePoint.index
		: (searchForwards ? 0 : xData.length - 1);

	const closestPointIndex = getClosestPointIndex(xData, domainXCoordinate, startIndex, searchForwards);
	const closestPoint = graph.config.data[closestPointIndex];

	const closestPointDomainX = xData[closestPointIndex];
	const closestPointX = xScale(closestPointDomainX);

	return {
		index: closestPointIndex,
		value: closestPoint,
		x: closestPointX,
		domainX: closestPointDomainX
	};

}

function getClosestPointIndex(xData, domainXCoordinate, startIndex, searchForwards) {

	let minDiff = Number.POSITIVE_INFINITY;
	let i = startIndex;

	const iterate = i => {
		const x = xData[i];
		const diff = Math.abs(domainXCoordinate - x);
		if (diff < minDiff) {
			minDiff = diff;
			return false;
		}
		return true;
	};

	// Find the index of the closest point by calculating the diff between each X value
	// and the domain X coordinate. The X data should be in order, so once we find
	// a diff larger than the previous we can stop searching. To optimise the algorithm,
	// we start at a previous index and search in the direction of change in the x-direction.

	if (searchForwards) {

		const n = xData.length;

		for (i = startIndex; i < n; i++) {

			const isDone = iterate(i);

			if (isDone) {
				break;
			}

		}

	} else {

		for (i = startIndex; i >= 0; i--) {

			const isDone = iterate(i);

			if (isDone) {
				break;
			}

		}

	}

	return searchForwards
		? i - 1
		: i + 1;

}



// WEBPACK FOOTER //
// ./utils/panelgraph/functions/get-closest-point.js